module.exports = __webpack_public_path__ + "static/mb_casestudy_glamira-ef98855275028718518ab49915785ad3.jpg";